// import external dependencies
import 'jquery';

// Import everything from autoload


// import local dependencies
import Slideshow from './lib/Slideshow';
import DcodeTabs from './lib/DcodeTabs';
import WindowPal from './lib/WindowPal';
import MobileBg from './lib/MobileBg';
import MobileNav from './lib/MobileNav';
import ScrollToTop from './lib/ScrollToTop';
import Modal from './lib/Modal';
import LoadMore from './lib/LoadMore';
import VimeoBlock from './lib/VimeoBlock';
import './lib/jquery.simplePagination';
import SearchField from './lib/SearchField';
import GoogleMultiMap from './lib/GoogleMultiMap';
import Block from './lib/Block';
import ScrollWatcher from './lib/ScrollWatcher';
import AccordionGallery from './lib/AccordionGallery';
import HideToRevealMobile from './lib/HideToRevealMobile';
import MobileCarousel from './lib/MobileCarousel';
import Accordion from './lib/Accordion';
import OpenSection from './lib/OpenSection';
import Postcode from './lib/Postcode';

import StickyApplyJobBtn from './lib/StickyApplyJobBtn';
import TextSlider from './lib/TextSlider';

$(() => {

    let $window = $(window),
        windowPal = new WindowPal($window),
        $body = $('html, body'),
        $contact = $('[name="contact"]');

    $('.paginate').each((i, el) => {
        let items = $(el).children(),
            $paginationConatainer = $(el).next('#pagination-container'),
            numItems = items.length,
            perPage = 10,
            $pageRange = $('.page-range'),
            showFrom = 1,
            showTo = perPage;

        items.slice(perPage).hide();
        if ($pageRange.length && numItems > perPage) {
            $paginationConatainer.pagination({
                items: numItems,
                itemsOnPage: perPage,
                cssStyle: 'light-theme',
                onPageClick: function (pageNumber) {
                    $body.animate({scrollTop: 0}, 1000);
                    showFrom = perPage * (pageNumber - 1);
                    showTo = showFrom + perPage;
                    if (showTo > numItems) {
                        showTo = numItems;
                    }
                    items.hide().slice(showFrom, showTo).show();
                    $pageRange.html(`${showFrom} - ${showTo} of `);
                },
            });
            $pageRange.html(`${showFrom} - ${showTo} of `);
        }
    });

    $('[data-slideshow]').each((i, el) => {
        new Slideshow($(el), windowPal);
    });

    $('.dcode-tabs').each((i, el) => {
        new DcodeTabs($(el), windowPal);
    });

    $('[data-mobile-bg]').each((i, el) => {
        new MobileBg($(el), windowPal);
    });


    let scrollWatcher = new ScrollWatcher(windowPal);

    $('[data-desktop-bg]').each((i, el) => {
        new Block($(el), scrollWatcher);
    });

    $('[data-mobile-nav]').each((i, el) => {
        new MobileNav($(el), windowPal);
    });

    $('section.page-section.-with-vimeo').each((i, el) => {
        new VimeoBlock($(el));
    });

    $('[href="#contact"]').click(() => {
        $body.stop().animate({
            scrollTop: $contact.offset().top,
        }, 800, 'swing');
        return false;
    });

    // $('.acf-map').each(function (i, el) {
    //     let map = new GoogleMap($(el));
    // });

    $('.modal').each((i, el) => {
        new Modal($(el), windowPal);
    });

    $('.load-more').each((i, el) => {
        new LoadMore($(el), 3);
    });

    // new ScrollToTop(windowPal, $body);
    new ScrollToTop(windowPal, $body);

    new StickyApplyJobBtn(windowPal, $body);

    let $pageFilter = $('.page-filter');
    if ($pageFilter.length > 0) {
        const $pageFilterBtns = $pageFilter.find('.button');

        $pageFilterBtns.each(function (i, el) {
            $(el).on('click', function (ev) {
                ev.preventDefault();
                let btnTarget = $(this).data('filter');
                $(`#${btnTarget}`).slideToggle();
                $(this).toggleClass('-light-grey');
                $(this).toggleClass('-blue');
            })
        });
    }

    $('[data-search]').each((i, el) => {
        new SearchField($(el));
    });

    $('.google-multi-map').each((i, el) => {
        new GoogleMultiMap(el);
    });

    $('.accordion-gallery').each((i, el)=>{
        new AccordionGallery($(el));
    });

    $('[data-hide-to-reveal-mobile]').each((i, el)=>{
        new HideToRevealMobile($(el), windowPal);
    });

    $('.mobile-carousel').each((i, el)=>{
        new MobileCarousel($(el), windowPal);
    });

    $('[data-accordion]').each((i, el)=>{
        new Accordion($(el));
    });

    let openSections = {};
    $('[data-open-section]').each((i, el)=>{
        let $trigger = $(el),
            sel = $trigger.data('open-section') || '.page-section.-staff-form';
        if ( ! openSections.hasOwnProperty(sel)) {
            let openSection = new OpenSection($(sel), $body);
            openSections[sel] = openSection;
        }
        openSections[sel].addTrigger($trigger);
    });

    $('[data-text-slider]').each((i, el)=>{
        new TextSlider($(el));
    });

    $('[data-autosubmit]').each((i, el)=>{
        let $el = $(el);
        let fieldSel = $el.data('autosubmit');
        let $field, sameField;
        if (fieldSel) {
            $field = $(fieldSel);
            sameField = false;
        } else {
            $field = $el;
            sameField = true;
        }
        let $form = $field.parents('form');
        $el.change(()=>{
            if ( ! sameField) {
                $field.val($el.val());
            }
            $form.submit();
        });
    });
});


function msieversion() {

    if (window.document.documentMode) {
        console.log('DCode: IE browser detected.')
        let pointers = document.querySelectorAll('.image-and-caption .-pointer');
        Array.from(pointers, function (item) {
            item.style.display = 'none';
        });

        let modals = document.querySelectorAll('[data-modal-window]');
        Array.from(modals, modal => {
            modal.style.overflowY = 'hidden';
        })
    }
    return false;
}
msieversion();


// WEBPACK FOOTER //
// ./scripts/main.js